module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 nonSMSLanguages.forEach((item, i)=> { ;
__p += '\r\n    ';
 let checked=item.threeLetterISOLanguageName==chatLanguage ? 'checked' : '' ; ;
__p += '\r\n        <li class="apexchat_qt_multi_choice_radio ' +
((__t = ( isRDPlus ? 'rd-plus' : '' )) == null ? '' : __t) +
'">\r\n            <label tabindex="0" class="livechat_label_container livechat_qt_mc_bottomsheet_options" rel="' +
((__t = ( i )) == null ? '' : __t) +
'"\r\n                id="livechat_qt_mc_bottomsheet_options_' +
((__t = ( i )) == null ? '' : __t) +
'">\r\n                <span class="language-name">\r\n                    ' +
((__t = ( item.languageFullName )) == null ? '' : __t) +
'\r\n                </span>\r\n                <input name="qtBottomSheetList" value="' +
((__t = ( item.threeLetterISOLanguageName )) == null ? '' : __t) +
'" type="radio"\r\n                    class="livechat_bottomsheet_input" id="apexchat_qt_multi_choice_radio_' +
((__t = ( i )) == null ? '' : __t) +
'" tabindex="-1"\r\n                    ' +
((__t = (checked )) == null ? '' : __t) +
'>\r\n                <span class="livechat_bottomsheet_checkmark">\r\n                    ';
 if(isRDPlus){ ;
__p += '\r\n                        <svg class="checked" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg"\r\n                            viewBox="0 0 448 512">\r\n                            <path\r\n                                d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z">\r\n                            </path>\r\n                        </svg>\r\n                        ';
 } ;
__p += '\r\n                </span>\r\n            </label>\r\n        </li>\r\n        ';
 }); ;


}
return __p
}